export default __webpack_public_path__ + "static/media/product.a33b1b5e.jpg";